import { createFileRoute } from '@tanstack/react-router';
import { BookingsContainer } from 'src/features/bookings/shared/containers/bookings';

export const Route = createFileRoute('/_layout/tenant/bookings/_layout')({
  component: BookingsContainer,
});
